<script setup lang="ts">
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import ForgotPasswordForm from '@/components/Auth/ForgotPasswordForm.vue'

definePage({
  meta: { ...PageMeta.Auth.forgotPassword.meta, pageTitle: PageMeta.Auth.forgotPassword.title },
})
</script>

<template>
  <ForgotPasswordForm />
</template>
